import React from "react";

function Location() {
  return (
    <div class="w-100 mt-4">
      <h3 class="text-center my-4">OUR LOCATION</h3>
      <iframe
      className="w-100 map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.050318776665!2d42.97699887573216!3d36.865214372228714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40088d002fc8aa0b%3A0x8488d2511308eac3!2sGanj%20Mesopotamia%20General%20Trading%20Ltd.!5e0!3m2!1sen!2siq!4v1733166403799!5m2!1sen!2siq"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        title="Solar Implements"
      ></iframe>
    </div>
  );
}

export default Location;

